import { useEffect, useState } from "react";

export const useCountdown = ({ type, time, reset }) => {
	const [timeLeft, setTimeLeft] = useState(time);

	const refreshTime = type === "minutes" ? 60000 : 1000;

	useEffect(() => {
		const interval = setInterval(() => {
			setTimeLeft(Math.max(timeLeft - 1, 0));
			if (timeLeft === 0) {
				return reset ? setTimeLeft(time) : clearInterval(interval);
			}
		}, refreshTime);

		return () => clearInterval(interval);
	}, [timeLeft]);

	return timeLeft;
};
